import React from "react";

function HelpArticlesComponent(props) {

  return (
    <div className="card">
      <div className="col-12 embed-responsive embed-responsive-16by9">
        <iframe src={process.env.REACT_APP_HELP_ARTICLES_URL} title="Huron Healthcare Market Insights Help Articles" className="embed-responsive-item"></iframe>
      </div>
    </div>
  );
}

export default HelpArticlesComponent;